<template>
  <div :class="componentClasses" @click="clicked()">
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 34C26.6127 34 34 26.6127 34 17.5C34 8.3873 26.6127 1 17.5 1C8.3873 1 1 8.3873 1 17.5C1 26.6127 8.3873 34 17.5 34Z" fill="#AFAFAF" fill-opacity="0.2"/>
    <path d="M34 17.5C34 26.6127 26.6127 34 17.5 34C8.3873 34 1 26.6127 1 17.5C1 8.3873 8.3873 1 17.5 1C26.6127 1 34 8.3873 34 17.5ZM2.485 17.5C2.485 25.7926 9.20744 32.515 17.5 32.515C25.7926 32.515 32.515 25.7926 32.515 17.5C32.515 9.20744 25.7926 2.485 17.5 2.485C9.20744 2.485 2.485 9.20744 2.485 17.5Z" fill="#AFAFAF"/>
    <path d="M12.1426 15.2851C13.3238 15.2851 14.2851 14.3238 14.2851 13.1426C14.2851 11.9613 13.3238 11 12.1426 11C10.9613 11 10 11.9613 10 13.1426C10 14.3238 10.9613 15.2851 12.1426 15.2851ZM12.1426 12.4284C12.5361 12.4284 12.8568 12.7491 12.8568 13.1426C12.8568 13.5361 12.5361 13.8568 12.1426 13.8568C11.7491 13.8568 11.4284 13.5361 11.4284 13.1426C11.4284 12.7491 11.7491 12.4284 12.1426 12.4284Z" fill="#AFAFAF"/>
    <path d="M23.5693 11C22.3881 11 21.4268 11.9613 21.4268 13.1426C21.4268 14.3238 22.3881 15.2851 23.5693 15.2851C24.7506 15.2851 25.7119 14.3238 25.7119 13.1426C25.7119 11.9613 24.7506 11 23.5693 11ZM23.5693 13.8568C23.1758 13.8568 22.8551 13.5361 22.8551 13.1426C22.8551 12.7491 23.1758 12.4284 23.5693 12.4284C23.9628 12.4284 24.2835 12.7491 24.2835 13.1426C24.2835 13.5361 23.9628 13.8568 23.5693 13.8568Z" fill="#AFAFAF"/>
    <path d="M24.998 19.5703H10.7142C10.32 19.5703 10 19.8903 10 20.2845C10 20.6787 10.32 20.9987 10.7142 20.9987H24.998C25.3922 20.9987 25.7122 20.6787 25.7122 20.2845C25.7122 19.8903 25.3922 19.5703 24.998 19.5703Z" fill="#AFAFAF"/>
    </svg>
  </div>
</template>

<script>
import iconMixin from '../../../mixins/component-mixins/root/iconMixin'

export default {
  name: 'IconMeh',
  mixins: [iconMixin],
  computed: {
    componentClasses: function () {
      return {
        'rc-icon': true,
        'rc-icon-Meh': true,
        ...this.componentSizeClasses,
        ...this.componentStateClasses
      }
    }
  }
}
</script>

<style scoped></style>
